import { Component, OnInit } from '@angular/core';
import { ModalService } from '@app/services/modal.service';

@Component({
  selector: 'app-modal-rate-success',
  templateUrl: './modal-rate-success.component.html',
  styleUrls: ['./modal-rate-success.component.scss']
})
export class ModalRateSuccessComponent implements OnInit {

  constructor(
    public modal: ModalService
  ) { }

  ngOnInit() {
  }

}
